module.exports = __webpack_public_path__ + "img/b2c45d5.jpg";